import { ProvidersProp } from "../../types/props/providers-prop";
import { AgGridProvider } from "ag-grid-react";
import { AllCommunityModule } from "ag-grid-community";
import { Toaster } from "react-hot-toast";
import { UserProvider } from "../../providers/user-provider";
import { KmsServiceProvider } from "../../providers/kms-service-provider";
import { MessagerieProvider } from "../../providers/messagerie-provider";

const modules = [AllCommunityModule];

export const LibClientProviders = ({ children }: ProvidersProp) => {
  return (
    <KmsServiceProvider>
      <UserProvider>
        <Toaster
          position="bottom-right"
          gutter={8}
          toastOptions={{
            duration: 4000,
            style: {
              background: "transparent",
              boxShadow: "none",
              padding: 0,
            },
          }}
        />
        <MessagerieProvider>
          <AgGridProvider modules={modules}>{children}</AgGridProvider>
        </MessagerieProvider>
      </UserProvider>
    </KmsServiceProvider>
  );
};
